import React, { useEffect, useState, useMemo } from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import { http } from "../helper";
import DataTable from "react-data-table-component";
import { BaseUrl } from "../common/config";
import Sidebar from "../common/sidebar";
import { canAction } from "../common/permissionhelper";
import { useTranslation } from "react-i18next";

const HoAccountcode = () => {
  const { t } = useTranslation();
  const [searchTextVal, setSearchTextVal] = useState("");
  const [accountcodelist, setAccountcodelist] = useState([]);
  const [templist, setTemplist] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [accountcodevalue, setAccountcodevalue] = useState("");
  // Auth & permission check
  useEffect(() => {
    if (!sessionStorage.getItem("isLoggedIn")) {
      window.location.href = "/";
      return;
    }
    const authData = JSON.parse(sessionStorage.getItem("authData"));
    if (authData && !authData.adminRole.permissions.includes("manage_ho")) {
      window.location.href = "/unauthorized";
      return;
    }
  }, []);
  // Fetch account code list
  useEffect(() => {
    getAccountcodelist();
  }, []);

  const getAccountcodelist = () => {
    const URL = BaseUrl + "admin/hoaccountcodelist";
    http
      .get(URL)
      .then((response) => {
        setAccountcodelist(response.data.data);
        setTemplist(response.data.data);
        setLoading(false);
      })
      .catch((err) => console.log(err));
  };
  // Search & filter
  const handleChange = (value) => {
    setSearchTextVal(value);
    filterData(value);
  };

  const filterData = (value) => {
    const lowercasedValue = value.toLowerCase().trim();
    if (!lowercasedValue) {
      setAccountcodelist(templist);
      return;
    }
    const result = templist.filter((item) =>
      (item.accountCode ?? "")
        .toString()
        .toLowerCase()
        .includes(lowercasedValue),
    );
    setAccountcodelist(result);
  };

  const handleReset = () => {
    setSearchTextVal("");
    setAccountcodelist(templist);
  };
  // CRUD actions
  const addaccountcode = () => {
    window.location.href = "/headoffice/accountcode/add/";
  };

  const editaccountcode = (value) => {
    window.location.href = `/headoffice/accountcode/edit/${value._id}/`;
  };

  const deleteAccountcode = (value) => {
    setVisibleAlert(true);
    setAccountcodevalue(value);
  };

  const deleteAccountcodeValue = () => {
    const URL = BaseUrl + `admin/hoaccountcode/${accountcodevalue._id}`;
    http
      .delete(URL)
      .then((response) => {
        if (response.data.success === true) {
          window.location.reload();
        }
      })
      .catch((err) => console.log(err));
  };

  const alertPopupclose = () => {
    setVisibleAlert(false);
    setAccountcodevalue("");
  };
  // DataTable columns
  const columns = useMemo(
    () => [
      {
        name: t("account_code_txt"),
        selector: (row) => row.accountCode,
        sortable: true,
      },
      {
        name: t("actions_txt"),
        cell: (row) => {
          const canEdit = canAction("manage_ho", "edit");
          return (
            <div style={{ display: "flex" }}>
              <a
                className="button title-tooltip title-up"
                data-title={canEdit ? t("edit_txt") : t("view_txt")}
                style={{ color: "white" }}
                onClick={() => editaccountcode(row)}
              >
                <i
                  className={`fa ${canEdit ? "fa-pencil" : "fa-eye"}`}
                  aria-hidden="true"
                ></i>
              </a>
              {canAction("manage_ho", "delete") && (
                <a
                  className="button title-tooltip title-up"
                  data-title={t("delete_txt")}
                  style={{ color: "white" }}
                  onClick={() => deleteAccountcode(row)}
                >
                  <i className="fa fa-trash" aria-hidden="true"></i>
                </a>
              )}
            </div>
          );
        },
        sortable: false,
      },
    ],
    [templist, t],
  );

  const customStyles = {
    rows: { style: { minHeight: "25px" } },
    headCells: { style: { padding: "8px" } },
    cells: { style: { padding: "8px" } },
  };

  const paginationComponentOptions = {
    rowsPerPageText: "",
    rangeSeparatorText: "",
    selectAllRowsItem: true,
    selectAllRowsItemText: "",
    noRowsPerPage: "",
  };

  return (
    <>
      <div className="dashboard-block">
        <Sidebar />
        <div className="dash-left">
          <Header />
          <section className="cart-block">
            <div className="container">
              <h1 className="checkout-title">
                {t("restricted_accounts_for_head_office_txt")}
              </h1>
              <div className="right-table-outer-wrap">
                <div className="table-filter search-orders">
                  <div className="table-search-reset">
                    <div className="table-search">
                      <input
                        type="text"
                        value={searchTextVal}
                        onChange={(e) => handleChange(e.target.value)}
                        className="form-control"
                        placeholder={t("search_by_code_txt")}
                      />
                    </div>
                    <button
                      className="submitbtn button search-holi-btn"
                      onClick={() => filterData(searchTextVal)}
                    >
                      <i className="fa fa-search"></i>
                    </button>
                    <button className="resetbtn" onClick={handleReset}>
                      {t("reset_txt")}
                    </button>
                  </div>
                  {canAction("manage_ho", "add") && (
                    <div className="add-holidaybtn">
                      <button className="addbtn" onClick={addaccountcode}>
                        {t("add_txt")}
                      </button>
                    </div>
                  )}
                </div>
                <div className="table_overflow">
                  <DataTable
                    columns={columns}
                    data={accountcodelist}
                    noDataComponent={
                      <div className="no-records-found">
                        {t("no_account_code_found_txt")}
                      </div>
                    }
                    customStyles={customStyles}
                    pagination
                    paginationPerPage={25}
                    progressPending={loading}
                    paginationRowsPerPageOptions={[25, 50, 75, 100]}
                    paginationComponentOptions={paginationComponentOptions}
                  />
                </div>
              </div>
            </div>
          </section>
          <Footer />
        </div>
      </div>
      {visibleAlert && (
        <div className="custom-alert-pop paylater-popup">
          <div className="custom-alert-container">
            <div className="custom-alert-wrap">
              <div className="custom-alert-header">
                <h4>{t("alert_txt")}</h4>
              </div>
              <div className="custom-alert-body">
                <p>{t("confirm_delete_txt")}</p>
                <div className="alert-buttons">
                  <a
                    onClick={deleteAccountcodeValue}
                    className="popup-alert-btn button"
                  >
                    {t("ok_txt")}
                  </a>
                  <a
                    onClick={alertPopupclose}
                    className="popup-alert-btn button"
                  >
                    {t("cancel_txt")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default HoAccountcode;
